import { SVGProps } from 'react';

const MapPinX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.752 11.901c.16-.621.244-1.26.248-1.901a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.292-.077M21.5 15.5l-5 5m5 0-5-5M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default MapPinX;
